import { Link } from 'react-router-dom';

export const TryItFree = () => {
  return (
    <section
      id="banner-1"
      className="pt--100 pt-[100px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] banner-section"
    >
      <div className="container">
        {/* BANNER-1 WRAPPER */}
        <div className="banner-1-wrapper rounded-[16px] relative overflow-hidden !text-center sm:max-md:mr-[-15px] sm:max-md:ml-[-15px] sm:max-md:my-0 sm:max-md:rounded-[0_0] xsm:max-sm:mr-[-15px] xsm:max-sm:ml-[-15px] xsm:max-sm:my-0 xsm:max-sm:rounded-[0_0]">
          <div className="banner-overlay bg--05 bg--fixed pt-[75px] !pb-[85px] px-[13%] lg:max-xl:pt-[60px] lg:max-xl:!pb-[70px] lg:max-xl:px-[15%] md:max-lg:pt-[45px] md:max-lg:!pb-[55px] md:max-lg:px-[12%] sm:max-md:pt-[55px] sm:max-md:!pb-[65px] sm:max-md:px-[60px] xsm:max-sm:pt-[60px] xsm:max-sm:!pb-[70px] xsm:max-sm:px-[30px] bg-scroll sm:max-md:w-auto xsm:max-sm:w-auto w-full bg-no-repeat bg-[center_center] bg-cover bg-[url(/images/bg-05.jpg)]">
            <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
              {/* BANNER-1 TEXT */}
              <div className="flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)]">
                <div className="banner-1-txt color--white">
                  {/* Title */}
                  <h2 className="s-45 w--700 xl:!text-[2.8125rem] lg:max-xl:!text-[2.5625rem] md:max-lg:!text-[2.20588rem] sm:max-md:!text-[2.25rem] xsm:max-sm:!text-[1.8125rem] !font-bold !tracking-[-0.5px] xl:!mb-[15px] lg:max-xl:!mb-[16px] md:max-lg:!mb-[16px] sm:max-md:!mb-[12px] xsm:max-sm:!mb-[12px] leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                    Ready to buy REALTOR.ca showing-request leads?
                  </h2>
                  {/* Text */}
                  <p className="p-xl !mt-0 !mb-[25px] lg:max-xl:!mt-[15px] md:max-lg:!mt-3 sm:max-md:!mt-[14px] xsm:max-sm:!text-[1.125rem] xsm:max-sm:!mt-[14px] lg:max-xl:!mb-[25px] md:max-lg:!mb-[20px] sm:max-md:!mb-[20px] xsm:max-sm:!mb-[20px]">
                    Open pricing and wallet options, or book a walkthrough of
                    territory targeting, shared vs exclusive lead delivery, and
                    how leads flow from Request a Showing — plus recorded demos
                    if you prefer to watch first.
                  </p>
                  {/* Buttons */}
                  <div className="flex flex-wrap items-center justify-center gap-3">
                    <Link
                      to="/pricing"
                      className="btn !rounded-[4px] btn--theme hover--tra-white"
                    >
                      Buy leads &amp; pricing
                    </Link>
                    <Link
                      to="/demo"
                      className="btn !rounded-[4px] hover--tra-white btn--tra-white"
                    >
                      Book live demo
                    </Link>
                    <Link
                      to="/instant-demo"
                      className="btn !rounded-[4px] hover--tra-white btn--tra-white"
                    >
                      Watch recorded demo →
                    </Link>
                  </div>
                  {/* Button Text */}
                  {/* <p className="p-sm btn-txt !m-[20px_0_0_0] lg:max-xl:!mt-[15px] lg:max-xl:!mb-0 lg:max-xl:mx-0 md:max-lg:!mt-[13px] md:max-lg:!mb-0 md:max-lg:mx-0 xsm:max-sm:!mt-[18px] xsm:max-sm:!mb-0 sm:max-md:!mt-[15px] sm:max-md:!mb-0 sm:max-md:mx-0 ico-15 opacity-[0.85] pl-[5px]">
                    <span className="flaticon-check relative right-[2px] top-[0.5px]"></span>{' '}
                    Two options available: pre-recorded demo or live demo with an expert
                  </p> */}
                </div>
              </div>
              {/* END BANNER-1 TEXT */}
            </div>
            {/* End row */}
          </div>
          {/* End banner overlay */}
        </div>
        {/* END BANNER-1 WRAPPER */}
      </div>
      {/* End container */}
    </section>
  );
};
